var render = function render(){var _vm=this,_c=_vm._self._c;return _c('state-container',{attrs:{"status":"loading","is-collapsible":""}},[_vm._v("\n  "+_vm._s(_vm.s__('mrWidget|Checking if merge request can be merged…'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }